import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import Button from '@mui/material/Button';
import secureLocalStorage from 'react-secure-storage';



const PDFGenerator = ({ contentRef }) => {  // Receive contentRef as prop

  const settings = secureLocalStorage.getItem("systemSettings");
  const settingsInfo = JSON.parse(settings);
  const mainBackground = settingsInfo?.mainBackground;

  const handlePrint = useReactToPrint({
    content: () => contentRef.current,
    pageStyle: `
      @page { 
        margin: 0 !important; 
        size: auto;
      }
      @media print {
        body { 
          -webkit-print-color-adjust: exact; 
          margin: 0 !important;
        }
        .print-container {
          padding: 10mm 5mm !important;
        }
      }
    `
  });

  return (
    <Button
      variant="contained"
      onClick={handlePrint}
      style={{ margin: '20px', backgroundColor: mainBackground }}
    >
      Generate PDF
    </Button>
  );
};

export default PDFGenerator;